import { useState } from "react";

import Toast                                      from "_common/toast";
import { useGetIsModerator, useGetPinnedComment } from "_components/features/ivsChat/states";
import { pinCommentSession }                      from "_services/api/broadcast";

import Presentation from "./presentation";

const component = props => {
	const {
		emotesList,
		isStreamer,
		userProfile,
		broadcastId,
		isMobile
	} = props;

	const isModerator                   = useGetIsModerator ();
	const pinnedComment                 = useGetPinnedComment ();
	const [ isReadMore, setIsReadMore ] = useState ( true );

	const toggleReadMore = () => {
		setIsReadMore ( prev => !prev );
	};

	const unPinComment = async () => {
		try {
			await pinCommentSession ( {
				broadcastSessionId : broadcastId,
				commentId          : pinnedComment?.id,
				flag               : 0
			} );

			Toast.info ( "Comment unpinned" );
		} catch ( err ) {
			Toast.error ( err.displayMsg );
		}
	};

	return (
		<Presentation
			emotesList        = { emotesList }
			isMobile          = { isMobile }
			isModerator       = { isModerator }
			isOwnProfile      = { userProfile && pinnedComment?.sportsFan?.id === userProfile.id }
			isReadMore        = { isReadMore }
			isStreamer        = { isStreamer }
			pinnedCommentData = { pinnedComment }
			toggleReadMore    = { toggleReadMore }
			unPinComment      = { unPinComment }
		/>
	);
};

export default component;
